import { ChangeDetectionStrategy, Component, effect, inject, input, output, signal } from '@angular/core';
import { ButtonType } from '../../enum/button-type.enum';
import { InputSize } from '../../enum/input-size.enum';
import { ButtonComponent } from '../../buttons/button/button.component';
import { Subject } from 'rxjs';
import { ConfirmationDialogComponent } from '../../dialog/confirmation-dialog/confirmation-dialog.component';
import { DialogUtils } from '../../../utils/dialog-utils';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'lib-editable-card',
  imports: [ButtonComponent],
  templateUrl: './editable-card.component.html',
  styleUrl: './editable-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditableCardComponent {
  private readonly dialog = inject(MatDialog);

  public titleText = input.required<string>();
  public isSaving = input<boolean>(false);
  public saveCompleteSubject = input<Subject<void> | null>(null);
  readonly isDirty = input<boolean>(false);
  public cancelClick = output<void>();
  public saveClick = output<void>();
  public isEditChange = output<boolean>();
  public isEditing = signal(false);
  protected readonly ButtonType = ButtonType;
  protected readonly InputSize = InputSize;

  saveCompleteEffect = effect(() => {
    this.saveCompleteSubject()?.subscribe(() => {
      this.isEditing.set(false);
    });
  });

  editEffect = effect(() => {
    this.isEditChange.emit(this.isEditing());
  });

  cancelClicked() {
    if (this.isDirty()) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, DialogUtils.smallDialogConfig());
      dialogRef.componentInstance.config.set({
        title: $localize`Are You Sure You Want to Cancel?`,
        message: $localize`Your changes will be discarded.`,
        primaryButtonText: $localize`Confirm Cancellation`,
        secondaryButtonText: $localize`Continue Editing`,
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.isEditing.set(false);
          this.cancelClick.emit();
        }
      });
    } else {
      this.isEditing.set(false);
    }
  }

  saveClicked() {
    this.saveClick.emit();
  }
}
